<template>
  <el-card class="community-selector">
    <div class="treeview attendance-staff">
      <ul class="community-list">
        <li 
          v-for="(item, index) in communityList" 
          :key="index" 
          @click="selectCommunity(item)"
          :class="{'selected': selectedCommunityId === item.communityId}">
          {{ item.name }}
        </li>
      </ul>
    </div>
  </el-card>
</template>

<script>
import { getMyEnteredCommunitys } from '@/api/community/communityApi'

export default {
  name: 'SelectAdminCommunity',
  data() {
    return {
      communityList: [],
      selectedCommunityId: ''
    }
  },
  created() {
    this.loadCommunities()
  },
  methods: {
    loadCommunities() {
      const params = {
        page: 1,
        row: 100
      }

      getMyEnteredCommunitys(params)
        .then(res => {
          // 鍏煎涓嶅悓杩斿洖缁撴瀯锛歳es.communitys / res.data
          const list = Array.isArray(res.communitys)
            ? res.communitys
            : (Array.isArray(res.data) ? res.data : [])
          this.communityList = [
            { name: this.$t('adminOwner.all'), communityId: '' },
            ...list
          ]
        })
        .catch(error => {
          // 鎵撳嵃閿欒锛屼絾涓嶆墦鏂〉闈娇鐢          console.log('加载小区列表失败:', error)
          this.$message.error(this.$t('adminOwner.fetchCommunityError') || '加载小区列表失败')
        })
    },
    selectCommunity(community) {
      this.selectedCommunityId = community.communityId
      this.$emit('changeCommunity', community)
    }
  }
}
</script>

<style lang="scss" scoped>
.community-selector {
  height: 100%;
  
  .community-list {
    list-style: none;
    padding: 0;
    margin: 0;
    
    li {
      padding: 10px;
      cursor: pointer;
      transition: all 0.3s;
      color: #606060;
      font-size: 14px;
      
      &:hover {
        background-color: #f5f7fa;
      }
      
      &.selected {
        background-color: #409EFF;
        color: white;
      }
    }
  }
}
</style>
